import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import MusicianBio from "./components/MusicianBio";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MusicianBio />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
